import React, { useEffect, useState } from 'react';
import './styles.scss';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
import { CallToAction } from 'components/atoms/callToAction';
import { Image } from 'components/atoms/image';
import Dotdotdot from 'react-dotdotdot';
import { HTMLView } from 'components/atoms/htmlView';

const TeamCard = props => {
  const data = props.data;
  const detailsPage = props.detailsPage;
  const [selected_name, set_selected_name] = useState('');
  const [selected_title, set_selected_title] = useState('');
  const thumbnailUrl = `${props.mediaPath.thumbnail}/${props.imagePath}`;
  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);
  const [overlay_page_data, set_overlay_page_data] = useState({});

  useEffect(() => {
    if (detailsPage) {
      checkOverlayCorrespondingFeature();
    }
  }, [selected_name]);

  const mediaPath = `${props.mediaPath.web}`;
  const checkOverlayCorrespondingFeature = () => {
    let overlaydata = {};
    set_overlay_page_data(overlaydata);
    Object.values(detailsPage).map((cmsdata, idx) => {
      if (data.name === cmsdata.page_title) {
        set_overlay_page_data(cmsdata);
        set_selected_title(cmsdata.page_title);
        return;
      }
    });
  };
  const handleLearnMore = name => {
    set_selected_name(name);
    checkOverlayCorrespondingFeature();
    setshowDescriptionLayout(true);
  };
  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={overlay_page_data}
        theme={'light-theme'}
        type={'leadership-overlay'}
        openFor={'leadership'}
        className={'ourHomesOverlay'}
        mediaPath={mediaPath}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'About',
            breadcrumbLink: RouteNames.about,
          },
          {
            breadcrumbName: 'Leadership',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'image-team-card'}>
      <div
        className={'inner-image-card'}
        onClick={() =>
          props.showOverlay === true && data.name === selected_title
            ? handleLearnMore(data.name)
            : null
        }
      >
        <div className={'team-image'}>
          <Image
            className={'image-class'}
            src={`${mediaPath}/${props.imagePath}`}
            thumbNail={thumbnailUrl}
            alt={'Team member'}
          />
        </div>
        <div className={'team-details'}>
          <h1 className={'team-name'}>{data.name}</h1>
          <span className={'team-member-role'}>{data.member_role}</span>
          <Dotdotdot clamp={5} tagName={'p'}>
            <HTMLView
              className={'team-description'}
              html={data.description}
              tagName={'p'}
            />
          </Dotdotdot>
          <div className={'intro-team'}>
            {props.showOverlay === true && data.name === selected_title ? (
              <div className={'explore-button'}>
                <CallToAction
                  onClick={() => handleLearnMore(data.name)}
                  text={'Learn More'}
                  mode={'transparent'}
                  type={'link'}
                  size={'small'}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {showOverlay}
    </div>
  );
};
export default TeamCard;
